import {
    SET_SIDE_OPTION,
    ADD_SIDE_LID,
    DUPLICATE_SIDE,
    ADD_SLEEVE,
    DELETE_SLEEVE,
    PUSH_LID_TO_TARGET,
    DELETE_LID,
    DELETE_FROM_PLAN,
    RESET,
    sleeveSize
} from "../constants/constants";

const initialState = [
    {
        name : "Side A",
        height: 100,
        duplicateSide : false,
        sleeves : [],
        lids : [
            {
                sagex : false,
                length : 100,
                height : 60,
                invisibleFlag: true
            }
        ]
    },
    {
        name : "Side B",
        height: 100,
        sleeves : [],
        duplicateSide : false,
        lids : [
            {
                sagex : false,
                length : 100,
                height : 60,
                invisibleFlag: true
            }
        ]
    },
    {
        name : "Side C",
        height: 100,
        duplicateSide : false,
        sleeves : [],
        lids : [
            {
                sagex : false,
                length : 100,
                height : 60,
                invisibleFlag: true
            }
        ]
    },
    {
        name : "Side D",
        height: 100,
        sleeves : [],
        duplicateSide : false,
        lids : [
            {
                sagex : false,
                length : 100,
                height : 60,
                invisibleFlag: true
            }
        ]
    }
];

export const buildValuesSides = (state = initialState, action) => {
    switch (action.type){
        case SET_SIDE_OPTION : {
            const newState  = JSON.parse(JSON.stringify(state));
            if(action.payload.lidIndex >= 0) {
                newState[action.payload.step].lids[action.payload.lidIndex] = {
                    ...newState[action.payload.step].lids[action.payload.lidIndex],
                    ...action.payload
                };
                return JSON.parse(JSON.stringify(newState))
            }
            /*** adding new params to chosen side ***/
            newState[action.payload.step] = { ...newState[action.payload.step], ...action.payload};
            return JSON.parse(JSON.stringify(newState))
        }
        case ADD_SIDE_LID : {
            const newState = JSON.parse(JSON.stringify(state));
            /*** adding +1 lid to chosen side with default settings***/
            newState[action.payload.step].lids.push({
                sagex : false,
                length : 100,
                height : 60
            });

            return newState;
        }
        case DELETE_LID : {
            const newState = JSON.parse(JSON.stringify(state));
            newState[action.payload.step - 2].lids.splice(action.payload.index, 1);
            return [
                ...newState
            ];
        }
        case DELETE_FROM_PLAN : {
            const newState = JSON.parse(JSON.stringify(state));
            delete newState[action.payload.step - 2].lids[action.payload.index].top;
            delete newState[action.payload.step - 2].lids[action.payload.index].left;
            newState[action.payload.step - 2].lids[action.payload.index].invisibleFlag = true;
            return [
                ...newState
            ];
        }
        case ADD_SLEEVE : {
            const newState = JSON.parse(JSON.stringify(state));
            if(action.payload.index >= 0){
                newState[action.payload.side].sleeves[action.payload.index] = {
                    background : action.payload.background,
                    top: action.payload.top,
                    left  : action.payload.left
                }
            }else{
                newState[action.payload.side].sleeves.push({
                    background : action.payload.background,
                    top: action.payload.top,
                    left  : action.payload.left
                });
            }

            return [
                ...newState
            ]
        }
        case DELETE_SLEEVE : {

            const newState = JSON.parse(JSON.stringify(state));
            newState[action.payload.side].sleeves.splice(action.payload.index, 1);

            return [
                ...newState
            ];
        }
        case DUPLICATE_SIDE : {
            const newState = JSON.parse(JSON.stringify(state));
            newState[action.payload.side + 1] = JSON.parse(JSON.stringify(newState[action.payload.side]));
            newState[action.payload.side + 1].sleeves = newState[action.payload.side + 1].sleeves.map((item) => {
                return {
                    ...item,
                    left : action.payload.length - (sleeveSize[item.background] + item.left)
                }
            });
            newState[action.payload.side + 1].lids = newState[action.payload.side + 1].lids.map((item) => {
                return {
                    ...item,
                    left : action.payload.length - (item.length + item.left)
                }
            });
            newState[action.payload.side + 1].duplicateSide = false;
            return newState
        }
        case PUSH_LID_TO_TARGET : {
            const newState = JSON.parse(JSON.stringify(state));
            newState[action.payload.step].lids[action.payload.lid] ={
                ...newState[action.payload.step].lids[action.payload.lid],
                top: action.payload.top,
                left : action.payload.left,
                invisibleFlag: false
            };
            return [
                ...newState
            ];
        }
        case RESET: {
            return initialState
        }
        default : {
            return state
        }
    }
};


// WEBPACK FOOTER //
// ./src/reducers/buildValuesSides.js